// extracted by mini-css-extract-plugin
module.exports = {"header":"AppHeader_header_1Dw4I"};